import { FC } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@features/ui';

interface ConfirmDisabledPopupProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}
export const ConfirmDisabledPopup: FC<ConfirmDisabledPopupProps> = ({
  open,
  onOpenChange,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader className="mb-5">
          <DialogTitle className="text-2xl text-center mb-[23px]">
            Confirm Disable Action
          </DialogTitle>
          <DialogDescription className="text-white text-[16px] text-center">
            Are you sure you want to disable the selected items? You can
            re-enable them later if needed.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <div className="flex items-center justify-center gap-10">
            <Button
              className={'w-15'}
              size={'sm'}
              variant={'secondary'}
              onClick={() => {
                onConfirm();
                onOpenChange(false);
              }}
            >
              OK
            </Button>
            <Button
              className={'w-15'}
              size={'sm'}
              onClick={() => {
                onOpenChange(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
